/**数字人模块 */
import request from '../request/http';
/**图片智能解析 */
export function DrawingParsing(data){
    return request({
        url: '/ai/img/pptPageParsing',
        method: 'post',
        params: data
    })
}
/**生成数字人视频 */
export function GenerateDigitalHumanVideo(data){
    return request({
        url: '/digitalhuman/digitalHumanVideo/generateDigitalHumanVideo',
        method: 'post',
        data
    })
}
/**生成进度查询(建议一秒查一次) */
export function QueryProgress(code){
    return request({
        url: `/digitalhuman/digitalHumanVideo/queryProgress/${code}`,
        method: 'get',
    })
}
/**获取数字人视频 */
export function GetDigitalHumanVideo(id){
    return request({
        url: `/digitalhuman/digitalHumanVideo/getDigitalHumanVideo/${id}`,
        method: 'get',
    })
}
/**获取数字人模型列表 */
export function GetDigitalHumanModelList(userName){
    return request({
        url: `/digitalhuman/digitalHumanModel/getDigitalHumanModelList?userName=${userName}`,
        method: 'get',
    })
}
/**生成数字人语音 */
export function GenerateDigitalHumanAudio(data){
    return request({
        url: `/digitalhuman/digitalHumanModel/generateDigitalHumanAudio`,
        method: 'post',
        data
    })
}
